(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[464],{

/***/ 40464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ab_blog_post_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11622);
/* harmony import */ var _ab_blog_post_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_ab_blog_post_scss__WEBPACK_IMPORTED_MODULE_1__);


var BlogPost = function(param) {
    var content = param.content, _classname = param.classname, classname = _classname === void 0 ? "" : _classname;
    // console.log("BlogPost", content);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "ab-blog-post ".concat(classname || ""),
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BlogPost);


/***/ }),

/***/ 11622:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);